import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
  ADD_UPDATE_ADDITIONAL_SERVICES_ACTION_TYPE,
  addUpdateAdditonalServicesUrl,
  GET_ADDITIONAL_SERVICES_ACTION_TYPE, getAdditonalServicesUrl, getServiceVendorPackageDetailsUrl, GET_SERVICE_VENDOR_PACKAGE_DETAILS_ACTION_TYPE, headers
} from "../../utils/constants";

export const get_additional_services_action = (orderID, centerID) => async (dispatch) => {
  // console.log('UserID :', UserID, "OrderID:",OrderID, "ClientID:", ClientID)

  console.log("additionalServices was called");
  try {
    const payload = {
      UserID: parseInt(sessionStorage.getItem('userId')),
      OrderID: orderID,
      CenterID: centerID,
    };
    const response = await axiosGet(getAdditonalServicesUrl, payload, headers);
    dispatch({
      type: GET_ADDITIONAL_SERVICES_ACTION_TYPE,
      payload: response,
    });
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const postUpdate_additional_services_action = (orderID, orderDtlID, centerID, unlistedAddServices, BookingDetailsAdditionalServices, ExternalServices, isEdit) => async (dispatch) => {

  console.log("add Update Additional Services was called");
  try {
    const payload = {
      UserID: parseInt(sessionStorage.getItem('userId')),
      OrderID: orderID,
      OrderDtlID: orderDtlID != '' ? orderDtlID : null,
      CenterID: centerID,
      UnlistedAddServices: unlistedAddServices,
      BookingDetailsAdditionalServices: BookingDetailsAdditionalServices,
      IncludedServices: null,
      ExternalServices: ExternalServices != '' ? ExternalServices : null,
      isEdit: isEdit != '' ? isEdit : 0,
    };
    console.log("AdditionalService", payload)
    const response = await axiosPost(addUpdateAdditonalServicesUrl, payload, headers);
    dispatch({
      type: ADD_UPDATE_ADDITIONAL_SERVICES_ACTION_TYPE,
      payload: response,
    });
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getServiceVendorPackageDetail_action = (CenterID, ServiceID, OrderID, FromPrice, ToPrice) => async (dispatch) => {

  try {
    const payload = {
      UserID: parseInt(sessionStorage.getItem('userId')),
      CenterID: CenterID,
      ServiceID: ServiceID,
      OrderID: OrderID,
      FromPrice: FromPrice,
      ToPrice: ToPrice,
    };
    console.log("getServiceVendorPackageDetail was called", payload);
    const response = await axiosGet(getServiceVendorPackageDetailsUrl, payload, headers);
    dispatch({
      type: GET_SERVICE_VENDOR_PACKAGE_DETAILS_ACTION_TYPE,
      payload: response,
    });
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
};